import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PriceCnvState } from './pricecnv.state';
import { priceCnvFeatureKey } from './pricecnv.reducers';

export const selectPriceCnvState = createFeatureSelector<PriceCnvState>(priceCnvFeatureKey);

export const selectPriceCnv = createSelector(selectPriceCnvState, (state: PriceCnvState) => state);